import ContentLoader from "react-content-loader";
import { merge } from "react-merge";
import { useMediaQuery } from "react-responsive";
import { Color } from "../../enums/Color";

const loaderStyle = {
  mobile : {
    width: "90.34vw",
    backgroundColor: Color.White, 
    padding: "0 2.13vw",
    zIndex: "1",
    height: "99.51vw",
    marginTop: "5.56vw"
  },
  desktop: {
    borderRadius: "0.52vw",
    width: "42.29vw",
    height: "24.73vw",
    marginLeft: "-3.00vw",
    marginBottom: "1.00vw",
    marginTop: "1.56vw"
  }
};

export const RecruiterPasswordLoader : React.FC = () => {
  const isMobile = useMediaQuery ({ query : "(max-width: 786px)"});
  var styles = loaderStyle.mobile;
  if(!isMobile) {
    let extendedStyle = merge(loaderStyle.mobile, loaderStyle.desktop);
    styles = extendedStyle;
  }

  return(          
    <div style={styles}>
      <ContentLoader
        speed={1}
        backgroundColor={Color.LoaderBackground}
        foregroundColor={Color.LoaderForeground}
        width= "auto"
        height= {styles.height}
      > 
        {isMobile ? <>
          <rect x="4%" y="0" rx="3" ry="3" width="37.96%" height="6.14%" />
          <rect x="0" y="8%" rx="3" ry="3" width="100%" height="12.28%" />
          <rect x="4%" y="30.28%" rx="3" ry="3" width="37.96%" height="6.14%" />
          <rect x="0" y="38.85%" rx="3" ry="3" width="100%" height="12.73%" />
          <rect x="4%" y="59.42%" rx="3" ry="3" width="37.96%" height="6.14%" />
          <rect x="0" y="67.42%" rx="3" ry="3" width="100%" height="12.73%" />
          <rect x="40.37%" y="85.6%" rx="3" ry="3" width="64.97%" height="12.73%" />
        </> : 
        <>
          <rect x="1.25%" y="0" rx="3" ry="3" width="11.33%" height="5.26%" />
          <rect x="0" y="7.36%" rx="3" ry="3" width="100%" height="14.73%" />
          <rect x="1.25%" y="30.52%" rx="3" ry="3" width="11.33%" height="5.26%" />
          <rect x="0" y="37.86%" rx="3" ry="3" width="100%" height="14.73%" />
          <rect x="1.25%" y="56.84%" rx="3" ry="3" width="11.33%" height="5.26%" />
          <rect x="0" y="64.21%" rx="3" ry="3" width="100%" height="14.73%" />
          <rect x="51.1%" y="83.15%" rx="3" ry="3" width="49%" height="10.5%" />
        </>} 
      </ContentLoader>  
    </div>                
  )
}